import { render, staticRenderFns } from "./WorkshopList.vue?vue&type=template&id=3de91d2e&scoped=true"
import script from "./WorkshopList.vue?vue&type=script&lang=ts"
export * from "./WorkshopList.vue?vue&type=script&lang=ts"
import style0 from "./WorkshopList.vue?vue&type=style&index=0&id=3de91d2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de91d2e",
  null
  
)

export default component.exports